function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import { Menu, Button, Space } from "antd";
import { ShieldLockFill, Speedometer, CupFill } from "react-bootstrap-icons";
import { Container, Row, Col } from "react-bootstrap";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SubMenu = Menu.SubMenu;
var DefaultNav = function DefaultNav(_ref) {
  var handleConnectButton = _ref.handleConnectButton;
  var _useState = useState('home'),
    _useState2 = _slicedToArray(_useState, 2),
    current = _useState2[0],
    setCurrent = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    drawerVisible = _useState4[0],
    setDrawerVisible = _useState4[1];
  var hideDrawer = function hideDrawer() {
    setDrawerVisible(false);
  };
  var handleClick = function handleClick(e) {
    setDrawerVisible(true);
  };
  return /*#__PURE__*/_jsx("div", {
    className: "nav-wrapper",
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: {
            span: 5
          },
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              padding: '8px',
              color: 'grey'
            },
            children: [/*#__PURE__*/_jsx("b", {
              children: "Plateforme"
            }), " de gestion de clinique"]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: {
            span: 2,
            offset: 1
          },
          md: {
            span: 2,
            offset: 1
          },
          sm: 4,
          xs: 4,
          className: "ant-menu-horizontal",
          children: /*#__PURE__*/_jsxs(Space, {
            align: "end",
            direction: "horizontal",
            children: [/*#__PURE__*/_jsx(ShieldLockFill, {
              size: 22
            }), /*#__PURE__*/_jsx("b", {
              children: "S\xE9curis\xE9e"
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: {
            span: 2
          },
          md: {
            span: 2
          },
          sm: 4,
          xs: 4,
          className: "ant-menu-horizontal",
          children: /*#__PURE__*/_jsxs(Space, {
            align: "end",
            direction: "horizontal",
            children: [/*#__PURE__*/_jsx(Speedometer, {
              size: 22
            }), /*#__PURE__*/_jsx("b", {
              children: "Efficace"
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: {
            span: 2
          },
          md: {
            span: 2
          },
          sm: 4,
          xs: 4,
          className: "ant-menu-horizontal",
          children: /*#__PURE__*/_jsxs(Space, {
            align: "end",
            direction: "horizontal",
            children: [/*#__PURE__*/_jsx(CupFill, {
              size: 22
            }), /*#__PURE__*/_jsx("b", {
              children: "Intuitive"
            })]
          })
        })]
      })
    })
  });
};
export default DefaultNav;